<template>
	<div>
		<div style="font-size:20px;float:left;margin:-35px 0 0 40px;font-weight:600">
			<img src="../../../assets/icon/返回.png" style="vertical-align: middle;margin-top:-2px" @click="close" />
			回款管理
		</div>
		<div style="background-color:white;margin:75px 40px 0 40px">
			<div style="padding:30px">
				<div style="background-color:#fdfdfd;padding:30px 50px;border:1px solid #f7f7f7">
					<div>
						<img src="../../../assets/icon/钱袋1￥.png" style="vertical-align: middle;margin-top:-3px" />
						<span style="color:#006E4B;font-size:18px;font-weight:600">保证金信息</span>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>公司名头：</span><span>{{manageList.partnerNmame}}</span>
						</div>
						<div class="text">
							<span>组织架构：</span><span>{{$globals.group_name}}/{{manageList.organizeName}}</span>
						</div>
						<div class="text">
							<span>项目名称：</span><span>{{manageList.project_name}}</span>
						</div>
						<div class="text">
							<span>金额：</span><span>{{manageList.money_amount}}</span>
						</div>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>未回款金额：</span>
							<span>{{manageList.uncollected_payment}}
								<img src="../../../assets/icon/冲账.png" style="vertical-align: middle;margin-top:-3px"
									@click="Balance()" />
								<img src="../../../assets/icon/转化履约金.png" style="vertical-align: middle;margin-top:-3px"
									@click="Change()" />
							</span>
						</div>
						<div class="text">
							<span>备注：</span><span>{{manageList.spare}}</span>
						</div>
						<div class="text">
							<span>付款时间：</span><span>{{manageList.payment_time}}</span>
						</div>
						<!-- <div  style="display:contents;width:28%">
							<span>付款凭证：</span><span><img src="../../../assets/2.jpg"/></span>
						</div> -->
					</div>
				</div>
			</div>
			<div style="margin:10px 50px">
				<span style="margin-right:10px;margin-left:10px">回款日期</span>
				<el-date-picker style="width:25%" v-model="condition.start_date" type="datetimerange" clearable
					range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd HH:mm" end-placeholder="结束日期"
					value-format="yyyy-MM-dd HH:mm">
				</el-date-picker>
				<el-button style="width:85px;height:41px" type="goon" @click="Find">查询</el-button>
				<el-button style="width:135px;height:41px" type="goon" @click="Plan">回款计划登记</el-button>
			</div>
			<div style="margin:3% 2% 0 2%">
				<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
					:data="tableData" tooltip-effect="dark" style="width: 100%" height="420"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"> </el-table-column>
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
					</el-table-column>
					<el-table-column prop="estimate_collection_date" label="预计回款时间" align="center">
					</el-table-column>
					<el-table-column prop="estimate_collection_amount" label="预计回款金额" align="center">
					</el-table-column>
					<el-table-column prop="reality_collection_date" label="实际回款日期" align="center">
					</el-table-column>
					<el-table-column prop="reality_collection_amount" label="实际回款金额" align="center">
					</el-table-column>
					<el-table-column prop="collection_voucher" label="回款凭证" align="center" width="100">
						<template slot-scope="scope">
							<img src="../../../assets/查看.png" @click="Voucher()" />
						</template>
					</el-table-column>
					<el-table-column prop="spare" label="备注" align="center" width="100">
					</el-table-column>
					<el-table-column prop="applicantName" label="操作人" align="center">
					</el-table-column>
					<el-table-column prop="modified_time" label="操作时间" align="center">
					</el-table-column>
					<el-table-column label="操作" align="center" width="200">
						<template slot-scope="scope">
							<img src="../../../assets/icon/回款登记1.png" @click="Update(scope.row.id)" />
							<img src="../../../assets/icon/修改.png" @click="Revise(scope.row)" />
							<img src="../../../assets/icon/删除.png" @click="Del(scope.row.id)" />
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-row style=" margin-left: 500px;margin-top: -20px;">
					<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
						layout=" prev, pager, next, jumper" :total="total">
					</el-pagination>
				</el-row>
			</div>
			<el-dialog title="冲账登记" :visible.sync="showBalance" width="25%" center="true" :close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="80px" :model="formLabelAlign">
						<el-form-item label="冲账金额">
							<el-input type="number" v-model="balance.amount" placeholder="请输入金额"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="balance.spare" placeholder="请输入备注内容"></el-input>
						</el-form-item>
						<el-form-item label="操作人">
							<el-input v-model="name" placeholder="请输入操作人" disabled></el-input>
						</el-form-item>
						<el-form-item label="操作时间">
							<el-date-picker style="width: 100%;" v-model="date" type="date" format="yyyy-MM-dd"
								placeholder="" disabled>
							</el-date-picker>
						</el-form-item>
						<div style="text-align:center">
							<el-button type="goon" @click="BalanceSave()">保存</el-button>
						</div>
						</el-button>
					</el-form>
				</div>
			</el-dialog>
			<el-dialog title="转化履约金" :visible.sync="showChange" width="25%" center="true" :close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="80px" :model="formLabelAlign">
						<el-form-item label="项目名称">
							<el-select v-model="change.project_id" placeholder="请选择项目名称" filterable
								style="width: 100%;">
								<el-option v-for="item in projectList" :key="item.project_id" :label="item.project_name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="转化金额">
							<el-input type="number" v-model="change.amount" placeholder="请输入金额"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="change.spare" placeholder="请输入备注内容"></el-input>
						</el-form-item>
						<el-form-item label="操作人">
							<el-input v-model="name" placeholder="" disabled></el-input>
						</el-form-item>
						<el-form-item label="操作时间">
							<el-date-picker style="width: 100%;" v-model="date" type="date" format="yyyy-MM-dd"
								placeholder="" disabled>
							</el-date-picker>
						</el-form-item>
						<div style="text-align:center">
							<el-button type="goon" @click="changeSave()">保存</el-button>
						</div>
						</el-button>
					</el-form>
				</div>
			</el-dialog>
			<el-dialog :title="plan.id == null || plan.id == '' ? '回款计划登记' : '回款计划修改'" :visible.sync="showPlan"
				width="30%" center="true" :close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="120px" :model="formLabelAlign">
						<el-form-item label="预计回款时间">
							<el-date-picker style="width: 100%;" v-model="plan.estimate_collection_date" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="预计回款金额">
							<el-input type="number" v-model="plan.estimate_collection_amount" placeholder="请输入预计回款金额"></el-input>
						</el-form-item>
						<div style="text-align:center">
							<el-button type="goon" @click="PlanSave()" v-if="plan.id == null || plan.id == ''">保存
							</el-button>
							<el-button type="goon" @click="ReviseSave()" v-else>保存</el-button>
						</div>
						</el-button>
					</el-form>
				</div>
			</el-dialog>
			<el-dialog title="回款登记" :visible.sync="showRegister" width="30%" center="true"
				:close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="120px" :model="formLabelAlign">
						<el-form-item label="实际回款时间">
							<el-date-picker style="width: 100%;" v-model="register.reality_collection_date" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="实际回款金额">
							<el-input type="number" v-model="register.reality_collection_amount" placeholder="请输入实际回款金额"></el-input>
						</el-form-item>
						<el-form-item label="回款凭证">
							<el-upload class="avatar-uploader" :action="$globals.http + '/file/upload'"
								:show-file-list="false" :on-success="handlePhotoSuccess">
								<img v-if="register.collection_voucher" :src="register.collection_voucher"
									class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="register.spare" placeholder="请输入备注"></el-input>
						</el-form-item>
						<div style="text-align:center">
							<el-button type="goon" @click="RegisterSave()">保存</el-button>
						</div>
						</el-button>
					</el-form>
				</div>
			</el-dialog>
			<el-dialog title="审核" :visible.sync="showBalanceTable" width="35%" center="true" :close-on-click-modal="false">
				<div style="width: 100%;">
					<div>审核名称：冲账审核</div>
					<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:data="tableBalance.examineDetailsList" tooltip-effect="dark" style="width: 100%" height="300"
						@selection-change="handleSelectionChange">
						<el-table-column label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column prop="node" label="节点" align="center">
						</el-table-column>
						<el-table-column prop="role_name" label="岗位" align="center">
						</el-table-column>
						<el-table-column prop="staff_name" label="审核总监" align="center">
						</el-table-column>
					</el-table>
					<div style="text-align: center;margin-top: 10px;">
						<el-button type="goon" @click="BalanceSaveTable()">确定</el-button>
					</div>
				</div>
				<div style="height: 30px;"></div>
			</el-dialog>
			<el-dialog title="审核" :visible.sync="showchangeTable" width="35%" center="true" :close-on-click-modal="false">
				<div style="width: 100%;">
					<div>审核名称：转化履约金审核</div>
					<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:data="tablechange.examineDetailsList" tooltip-effect="dark" style="width: 100%" height="300"
						@selection-change="handleSelectionChange">
						<el-table-column label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column prop="node" label="节点" align="center">
						</el-table-column>
						<el-table-column prop="role_name" label="岗位" align="center">
						</el-table-column>
						<el-table-column prop="staff_name" label="审核总监" align="center">
						</el-table-column>
					</el-table>
					<div style="text-align: center;margin-top: 10px;">
						<el-button type="goon" @click="changeSaveTable()">确定</el-button>
					</div>
				</div>
				<div style="height: 30px;"></div>
			</el-dialog>
			
		</div>

	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		props: ["manageList"],
		data() {
			return {
				ids: [],
				total: 0,
				input: '',
				showBalance: false,
				showChange: false,
				showPlan: false,
				showRegister: false,
				showBalanceTable: false,
				tableBalance: {},
				showchangeTable: false,
				tablechange:[],
				projectList:[],
				ruleForm: {
					post_id: '',
				},
				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					id: '',
					start_date: '',
					end_date: '',
					tender_id: '',
				},

				plan: {
					id: '',
					tender_idtender_id: '',
					estimate_collection_date: '',
					estimate_collection_amount: '',
				},
				register: {
					id: '',
					collection_voucher: '',
					tender_id: '',
					applicant_id:'',
					reality_collection_date: '',
					reality_collection_amount: '',
					spare: '',
				},
				balance: {
					id: '',
					tender_id: '',
					amount: '',
					spare: '',
					applicant_id: this.$globals.user.id,
				},
				change: {
					amount:'',
					tender_id:'',
					project_id: '',
					applicant_id: this.$globals.user.staff_id,
				},
				name: this.$globals.user.name,
				date: this.getNowTime(),
				multipleSelection: [],
				input: '',
				tableData: [],

			};
		},

		mounted() {
			this.Find();
		},
		methods: {
			getNowTime() {
				var now = new Date();
				var year = now.getFullYear(); //得到年份
				var month = now.getMonth(); //得到月份
				var date = now.getDate(); //得到日期
				month = month + 1;
				month = month.toString().padStart(2, "0");
				date = date.toString().padStart(2, "0");
				var defaultDate = `${year}-${month}-${date}`;
				return defaultDate;
			},
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//查询
			async Find() {
				var content = {
					page_num: this.condition.page_num,
					page_size: this.condition.page_size,
					id: this.condition.id,
					end_date: this.condition.start_date != null && this.condition.start_date != '' ?
					this.condition.start_date[1] : '',
					start_date: this.condition.start_date != null && this.condition.start_date != '' ?
					this.condition.start_date[0] : '',
					tender_id: this.manageList.id,
				}
				var data = await this.$globals.AxiosPost('tenderBondCollection/getList', content);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			 Balance() {
				this.showBalance = true;
			},
			async BalanceSave() {
				this.balance.tender_id = this.manageList.id;
				var data = await this.$globals.AxiosPost('tenderBond/getReversalRecordApproval', this.balance);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showBalance = false;
						this.showBalanceTable = true;
						this.tableBalance = data;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async BalanceSaveTable() {
				var record = {
					tender_id : this.manageList.id,
					project_id : this.balance.project_id,
					amount : this.balance.amount,
					applicant_id : this.balance.applicant_id,
					approval: this.tableBalance,
				}
				var data = await this.$globals.AxiosPost('tenderBond/reversalRecord', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showBalance = false;
						this.showBalanceTable = false;
						this.$message.success(data);
						this.balance = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async Change() {
				var projectList = await this.$globals.AxiosPost("tenderHonourAgreement/getProjectList", {});
				this.projectList = projectList.data;
				this.showChange = true
			},
			async changeSave(){
				this.change.tender_id = this.manageList.id;
				var data = await this.$globals.AxiosPost('tenderBond/getChangeApproval', this.change);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showChange = false;
						this.showchangeTable = true;
						this.tablechange = data;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
				
			},
			
			async changeSaveTable() {
				var record = {
					tender_id : this.manageList.id,
					project_id : this.change.project_id,
					amount : this.change.amount,
					applicant_id : this.change.applicant_id,
					spare : this.change.spare,
					approval: this.tablechange,
					}
				var data = await this.$globals.AxiosPost('tenderBond/change', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showChange = false;
						this.showchangeTable = false;
						this.$message.success(data);
						this.change = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Plan() {
				this.showPlan = true
			},
			async PlanSave() {
				this.plan.tender_id = this.manageList.id;
				var data = await this.$globals.AxiosPost('tenderBondCollection/add', this.plan);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showPlan = false;
						this.$message.success(data);
						this.plan = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Revise(e) {
				this.plan = e;
				this.showPlan = true;
			},
			async ReviseSave() {
				this.plan.tender_id = this.manageList.id;
				var data = await this.$globals.AxiosPost('tenderBondCollection/update', this.plan);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showPlan = false;
						this.$message.success(data);
						this.plan = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Update(e) {
				this.register.id = e;
				this.showRegister = true;
			},
			async RegisterSave() {
				this.register.tender_id = this.manageList.id;
				this.register.applicant_id = this.$globals.user.staff_id;
				var data = await this.$globals.AxiosPost('tenderBondCollection/planAdd', this.register);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showRegister = false;
						this.$message.success(data);
						this.register = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async Del(e) {
				var record = {
					ids: [e],
				};
				var data = await this.$globals.AxiosPost('tenderBondCollection/del', record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			handlePhotoSuccess(res, file) {
				this.register.collection_voucher = res.data.fileUrl;
			},
			close() {
				this.$emit('close')
			},

		},
		async created() {
			
		},
	};
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: 300px;
		display: block;
	}
</style>
<style scoped>
	.el-aside {
		height: 700px;
		background-color: #fbfbfb;
	}

	.text {
		width: 25%
	}

	.s {
		width: 260px;
		display: block;
		margin: 20px auto;
	}

	.bor {
		font-size: 20px;
	}

	.add {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #fff;
		background-color: #00724e;
	}

	.add2 {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #00724e;
		background-color: #fff;
		border: 1px solid #00724e;
	}

	.el-table {
		width: 850px;
		margin-top: 40px;
	}

	.el-pagination {
		width: 500px;
		text-align: center;
		margin-top: 30px;
	}

	.prev {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 390px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.ne {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 460px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.c {
		position: absolute;
		top: 1px;
		left: 560px;
	}

	.small {
		width: 50px;
		height: 20px;
	}

	.btn {
		width: 60px;
		height: 30px;
		position: absolute;
		background-color: #00724e;
		top: 5px;
		left: 680px;
		color: #fff;
		border-radius: 5px;
	}

	.input {
		width: 200px;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.rz {
		margin-top: 20px;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 150px;
	}

	.el-dropdown /deep/ .el-button-group .el-button {
		width: 90px;
	}

	.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
		background-color: #00724e;
	}

	.el-table /deep/ thead {
		color: #000;
		font-weight: 700;
		background-color: #f0f0f0;
	}

	.bm {
		position: relative;
		height: 100px;
	}

	.el-button {
		background-color: #00724e;
		color: #fff;
		width: 100px;
	}

	.Time {
		margin-left: 80px;
	}

	.time {
		margin-bottom: 20px;
	}

	.money {
		margin-bottom: 50px;
	}

	.el-button--qian {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 13px;
		height: 40px;
		width: 80px;
	}

	.el-button--qian:focus,
	.el-button--qian:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// manage.vue?4c327264